/* Carbon Society - wheel customizer (conditional options + priced upgrades)
 * v2: the same options, pricing and cart logic, presented as a 4-stage builder:
 *   1 Vehicle & Fitment | 2 Wheel Design | 3 Components & Upgrades | 4 Review
 * Option data, prices, conditions, cart property names/values and the upgrade
 * line items are unchanged from v1 - only the layout and labels shown on screen changed.
 */
(function () {
  var root = document.querySelector('[data-cc]');
  if (!root) return;
  var form = document.getElementById(root.dataset.form);
  if (!form) return;

  var moneyFormat = root.dataset.moneyFormat || '${{amount}}';
  var basePrice = parseInt(root.dataset.basePrice, 10) || 0;
  var priceEls = document.querySelectorAll('[data-price]');
  var bar = document.querySelector('[data-cc-bar]');
  var opts = [], dict = null, uid = 'cs' + Date.now().toString(36);
  var stages = [], current = 0, reviewEl = null, atcBtn = null, atcNote = null, qtyInput = null;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var STAGES = [
    { key: 'fit', title: 'Vehicle & Fitment', text: 'Tell us about your car so we can confirm fitment.' },
    { key: 'design', title: 'Wheel Design', text: 'Shape, leather, stitching and materials.' },
    { key: 'parts', title: 'Components & Upgrades', text: 'Airbag cover, trims, LED display, paddle shifters and other upgrades.' },
    { key: 'review', title: 'Review', text: 'Check your build, add any notes and add it to your cart.' }
  ];

  function money(cents) {
    var n = (cents / 100).toFixed(2), parts = n.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return moneyFormat.replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]).replace(/\{\{\s*amount\s*\}\}/, withCommas).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withCommas.replace('.', ','));
  }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  /* Display-only spelling fixes. Stored values (used for conditions, pricing and cart properties) are untouched. */
  function show(s) { return String(s).replace(/\bSmoothe\b/g, 'Smooth').replace(/\bsmoothe\b/g, 'smooth').replace(/\bColour/g, 'Color').replace(/\bcolour/g, 'color').trim(); }
  function scrollToEl(node) { if (node) node.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' }); }

  /* ---------- swatch visuals ---------- */
  var COLORS = [
    ['kyalami', '#d9531e'], ['arancia', '#f07c18'], ['mandarin', '#f39a2c'], ['blushing pink', '#e7a6b5'],
    ['motorsport light blue', '#4fa3d9'], ['light blue', '#4fa3d9'], ['tiffany', '#81d8d0'], ['faunus', '#6d8f2e'], ['ulysses', '#3c5a3a'],
    ['toyota orange', '#f05a1a'], ['giallo', '#f5c400'], ['crema', '#efe1c3'], ['divo', '#2b5fae'], ['lime', '#a7d129'],
    ['wine', '#6e1423'], ['dark grey', '#45484d'], ['matte black', '#1d1d1f'], ['gloss black', '#0b0b0c'], ['beige', '#d8c3a0'],
    ['white', '#f2f2f2'], ['black', '#141414'], ['red', '#c1121f'], ['orange', '#e8731a'], ['brown', '#6b4228'],
    ['yellow', '#f2c400'], ['blue', '#1f4fd1'], ['grey', '#8b9096'], ['gray', '#8b9096'], ['green', '#2e7d32'],
    ['purple', '#6b2fa0'], ['gold', '#c9a227'], ['silver', '#c0c4c8'], ['pink', '#e48cb0']
  ];
  function colorsIn(name) {
    var n = name.toLowerCase(), found = [], used = n;
    COLORS.forEach(function (c) { var i = used.indexOf(c[0]); if (i > -1) { found.push([i, c[1]]); used = used.slice(0, i) + '#'.repeat(c[0].length) + used.slice(i + c[0].length); } });
    return found.sort(function (a, b) { return a[0] - b[0]; }).map(function (f) { return f[1]; });
  }
  function swatchStyle(name, title) {
    var n = name.toLowerCase(), t = (title || '').toLowerCase(), c = colorsIn(name);
    if (/^none\b/.test(n)) return { cls: 'none' };
    if (n === 'other') return { cls: 'other', text: '?' };
    if (n.indexOf('premium colors') > -1) return { cls: 'premium' };
    if (/bmw tri/.test(n)) return { bg: 'linear-gradient(90deg,#4fa3d9 0 33%,#1c3f94 33% 66%,#d0021b 66%)' };
    if (/german tri/.test(n)) return { bg: 'linear-gradient(90deg,#111 0 33%,#d0021b 33% 66%,#f2c400 66%)' };
    if (/italian tri/.test(n)) return { bg: 'linear-gradient(90deg,#1e8f3a 0 33%,#f2f2f2 33% 66%,#d0021b 66%)' };
    if (/chrome/.test(n)) return { bg: 'linear-gradient(135deg,#7d8186,#f4f5f6 45%,#8a8e93 55%,#e9eaeb)' };
    if (/3d leather/.test(n)) return { cls: 'leather', bg: '#2a2a2a' };
    var base = c[0] || '#151515';
    if (/honeycomb/.test(n)) return { cls: 'honeycomb', bg: base };
    if (/forged|flakes/.test(n)) return { cls: 'forged', bg: c.length && /flakes/.test(n) ? c[0] : '#1a1a1a', accent: c[0] || '#555' };
    if (/twill|dotted|carbon/.test(n) || (/carbon/.test(t) && /&|e-\d/.test(n))) {
      if (/&/.test(n)) return { cls: 'twill', bg: c[0] || '#111', accent: c[1] || '#666' };
      return { cls: /dotted/.test(n) ? 'dotted' : 'twill', bg: /black twill|dotted/.test(n) ? '#111' : base, accent: /black twill|dotted/.test(n) ? '#4a4a4a' : 'rgba(255,255,255,.35)' };
    }
    if (/perforated/.test(n)) return { cls: 'perforated', bg: c[0] || '#1a1a1a' };
    if (/alcantara/.test(n)) return { cls: 'suede', bg: c[0] || '#2b2b2b' };
    if (/smooth/.test(n)) return { cls: 'smooth', bg: c[0] || '#1a1a1a' };
    if (c.length) return { bg: c.length > 1 && /&/.test(n) ? 'linear-gradient(135deg,' + c[0] + ' 50%,' + c[1] + ' 50%)' : c[0] };
    return null;
  }
  function makeSwatch(name, title) {
    var s = swatchStyle(name, title);
    if (!s) return null;
    var sw = el('span', 'cc-sw' + (s.cls ? ' cc-sw--' + s.cls : ''));
    sw.setAttribute('aria-hidden', 'true');
    if (s.bg) sw.style.setProperty('--sw', s.bg);
    if (s.accent) sw.style.setProperty('--sw2', s.accent);
    if (s.text) sw.textContent = s.text;
    return sw;
  }

  /* ---------- stage assignment (by option title) ---------- */
  function ownStage(title, type) {
    var t = title.toLowerCase();
    if (type === 't' && /comment|let us know/.test(t)) return 3;            // notes -> Review
    if (/^\s*[1-5](\.\d+)*\.?\s/.test(title)) return 1;                       // 1.-5. shape, leather, strip, stitching, material
    if (/^\s*[6-9](\.\d+)*\.?\s/.test(title)) return 2;                       // 6. airbag, 7. trims
    if (/upgrad|would you like to include|included in/.test(t)) return 2;
    if (/vehicle|model\b|^make$|year|^does your|current|currently|upload|photo/.test(t)) return 0;
    if (/airbag|trim|\bled\b|paddle|shifter|button|satellite|display|heating/.test(t)) return 2;
    if (/shape|leather|strip|stitch|material|carbon|color/.test(t)) return 1;
    return -1;
  }
  function assignStages() {
    opts.forEach(function (o) {
      var s = ownStage(o.title, o.type);
      var parent = o.cond >= 0 ? opts[o.cond] : null;
      var ps = parent && parent.stage != null ? parent.stage : (parent ? ownStage(parent.title, parent.type) : -1);
      if (s < 0) s = ps >= 0 ? ps : 2;
      if (s !== 3 && ps > s) s = ps;          // a follow-up question never appears before its parent
      o.stage = s;
    });
  }

  /* ---------- build ---------- */
  function splitTitle(t) {
    var m = t.match(/^(.{6,90}?)[\s]*[(:]\s*(.+)$/);
    if (t.length > 80 && m) return [m[1].replace(/[:\s]+$/, ''), t.slice(m[1].length).replace(/^[\s:]+/, '').replace(/^\((.*)\)$/, '$1')];
    return [t.replace(/:$/, ''), ''];
  }
  function buildOption(r, i) {
    var title = dict.T[r[0]], type = r[1], req = !!r[2], cond = r[3], cv = r[4];
    var values = r[5] >= 0 ? dict.L[r[5]] : [];
    var o = { i: i, title: title, type: type, req: req, cond: cond, cv: cv, values: values, value: '', price: 0, el: null };
    var id = 'cc-' + uid + '-' + i;
    var box = el('div', 'cc-opt cc-opt--' + type);
    box.id = id + '-box';
    var parts = splitTitle(title);
    var head = el('div', 'cc-opt__head');
    var lab = el(type === 't' || type === 'f' ? 'label' : 'span', 'cc-opt__label', show(parts[0]));
    lab.id = id + '-label';
    if (type === 't' || type === 'f') lab.htmlFor = id;
    head.appendChild(lab);
    if (req) head.appendChild(el('span', 'cc-req', 'Required'));
    o.sel = el('span', 'cc-opt__sel'); head.appendChild(o.sel);
    box.appendChild(head);
    var described = [];
    if (parts[1]) { var help = el('p', 'cc-opt__help', show(parts[1])); help.id = id + '-help'; described.push(help.id); box.appendChild(help); }
    o.err = el('p', 'cc-err', ''); o.err.id = id + '-err'; described.push(o.err.id);
    if (type === 'b' || type === 'i') {
      var list = el('div', type === 'i' ? 'cc-swatches' : 'cc-buttons');
      list.setAttribute('role', 'radiogroup');
      list.setAttribute('aria-labelledby', lab.id);
      list.setAttribute('aria-describedby', described.join(' '));
      if (req) list.setAttribute('aria-required', 'true');
      o.group = list;
      values.forEach(function (v) {
        var key = String(v[0]).trim(), price = v[1] ? Math.round(v[1] * 100) : 0;
        if (!key) return;
        var lbl = el('label', type === 'i' ? 'cc-tile' : 'cc-pill');
        var inp = el('input'); inp.type = 'radio'; inp.name = id; inp.setAttribute('form', 'cc-detached'); inp.value = key; inp.className = 'visually-hidden';
        inp.addEventListener('change', function () { o.value = key; o.price = price; update(); });
        lbl.appendChild(inp);
        if (type === 'i') { var sw = makeSwatch(key, title); if (sw) lbl.appendChild(sw); else lbl.classList.add('cc-tile--text'); }
        lbl.appendChild(el('span', 'cc-val', show(key)));
        if (price) lbl.appendChild(el('span', 'cc-add', '+' + money(price)));
        list.appendChild(lbl);
      });
      box.appendChild(list);
    } else if (type === 't') {
      var long = /comment|details|let us know/i.test(title);
      var input = el(long ? 'textarea' : 'input', 'cc-text'); if (!long) input.type = 'text'; else input.rows = 3;
      input.id = id;
      input.setAttribute('aria-describedby', described.join(' '));
      if (req) input.setAttribute('aria-required', 'true');
      input.addEventListener('input', function () { o.value = input.value.trim(); update(); });
      o.input = input; box.appendChild(input);
    } else if (type === 'f') {
      var file = el('input', 'cc-file'); file.type = 'file'; file.accept = 'image/*';
      file.id = id;
      file.setAttribute('aria-describedby', described.join(' '));
      file.addEventListener('change', function () { o.value = file.files[0] ? file.files[0].name : ''; update(); });
      o.file = file; box.appendChild(file);
    }
    box.appendChild(o.err);
    o.el = box;
    return o;
  }

  function stageStatus(s) {
    var vis = s.opts.filter(visible), req = vis.filter(function (o) { return o.req; });
    var missing = req.filter(function (o) { return !o.value; }).length;
    return { missing: missing, required: req.length, visible: vis.length };
  }

  function build(rows) {
    rows.forEach(function (r, i) { opts.push(buildOption(r, i)); });
    assignStages();

    var wrap = el('div', 'cc cc--staged');
    wrap.appendChild(el('h2', 'visually-hidden', 'Build your wheel'));
    var progress = el('div', 'cc-progress');
    progress.innerHTML = '<p class="cc-progress__text" aria-live="polite"></p><div class="cc-progress__bar" aria-hidden="true"></div>';
    wrap.appendChild(progress);

    var notes = form.querySelector('[data-build-notes]'); if (notes) notes.remove();
    document.querySelectorAll('.product-form__dynamic').forEach(function (d) { d.remove(); });
    var row = form.querySelector('.product-form__row');
    qtyInput = form.querySelector('input[name="quantity"]');
    atcBtn = form.querySelector('[data-add-button]');

    STAGES.forEach(function (def, si) {
      var stageOpts = opts.filter(function (o) { return o.stage === si; });
      if (si < 3 && !stageOpts.length) return;
      var s = { index: si, def: def, opts: stageOpts };
      var sec = el('section', 'cc-stage');
      sec.id = uid + '-stage-' + si;
      var h = el('h3', 'cc-stage__heading');
      var btn = el('button', 'cc-stage__toggle'); btn.type = 'button';
      btn.setAttribute('aria-controls', sec.id + '-panel');
      btn.innerHTML = '<span class="cc-stage__num" aria-hidden="true"></span><span class="cc-stage__titles"><span class="cc-stage__title"></span><span class="cc-stage__summary"></span></span><span class="cc-stage__status"></span><span class="cc-stage__chev" aria-hidden="true"></span>';
      btn.querySelector('.cc-stage__title').textContent = def.title;
      btn.addEventListener('click', function () { open(stages.indexOf(s), true); });
      h.appendChild(btn); sec.appendChild(h);
      var panel = el('div', 'cc-stage__panel'); panel.id = sec.id + '-panel';
      panel.setAttribute('role', 'region'); panel.setAttribute('aria-labelledby', sec.id + '-title');
      btn.querySelector('.cc-stage__title').id = sec.id + '-title';
      panel.appendChild(el('p', 'cc-stage__intro', def.text));
      var body = el('div', 'cc-stage__body');
      if (si === 3) { reviewEl = el('div', 'cc-review'); body.appendChild(reviewEl); }
      stageOpts.forEach(function (o) { body.appendChild(o.el); });
      if (si === 3 && row) {
        body.appendChild(row);
        atcNote = el('p', 'cc-atc-note'); atcNote.id = uid + '-atc-note';
        body.appendChild(atcNote);
        if (atcBtn) atcBtn.setAttribute('aria-describedby', atcNote.id);
      }
      panel.appendChild(body);
      var nav = el('div', 'cc-stage__nav');
      s.back = el('button', 'cc-btn cc-btn--ghost', 'Back'); s.back.type = 'button';
      s.back.addEventListener('click', function () { open(stages.indexOf(s) - 1, true); });
      nav.appendChild(s.back);
      if (si < 3) {
        s.next = el('button', 'cc-btn', 'Continue'); s.next.type = 'button';
        s.next.addEventListener('click', function () { next(s); });
        nav.appendChild(s.next);
      }
      panel.appendChild(nav);
      sec.appendChild(panel);
      s.sec = sec; s.btn = btn; s.panel = panel;
      stages.push(s); wrap.appendChild(sec);
    });

    stages.forEach(function (s, n) {
      s.btn.querySelector('.cc-stage__num').textContent = n + 1;
      s.back.hidden = n === 0;
      if (s.next) s.next.textContent = 'Continue to ' + stages[n + 1].def.title;
    });
    progress.querySelector('.cc-progress__bar').innerHTML = stages.map(function () { return '<span></span>'; }).join('');

    root.appendChild(wrap);
    root.hidden = false;
    if (bar) {
      bar.hidden = false;
      var go = bar.querySelector('[data-cc-goto-review]');
      if (go) go.addEventListener('click', function (e) { e.preventDefault(); open(stages.length - 1, true); });
    }
    open(0, false);
    update();
  }

  function open(n, focus) {
    if (n < 0 || n >= stages.length) return;
    current = n;
    stages.forEach(function (s, i) {
      var on = i === n;
      s.sec.classList.toggle('is-open', on);
      s.panel.hidden = !on;
      s.btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) s.btn.setAttribute('aria-current', 'step'); else s.btn.removeAttribute('aria-current');
    });
    update();
    if (focus) { scrollToEl(stages[n].sec); stages[n].btn.focus({ preventScroll: true }); }
  }

  function showErrors(list) {
    list.forEach(function (o) {
      o.err.innerHTML = '<span class="cc-err__icon" aria-hidden="true">!</span> ' + (o.type === 't' ? 'Required: please fill this in.' : 'Required: please make a selection.');
      o.el.classList.add('is-invalid');
      var ctl = o.group || o.input || o.file; if (ctl) ctl.setAttribute('aria-invalid', 'true');
    });
  }
  function missingIn(list) { return list.filter(function (o) { return visible(o) && o.req && !o.value; }); }
  function focusOption(o) {
    var target = o.input || o.file || (o.group && (o.group.querySelector('input:checked') || o.group.querySelector('input')));
    scrollToEl(o.el);
    if (target) target.focus({ preventScroll: true });
  }
  function next(s) {
    var miss = missingIn(s.opts);
    if (miss.length) { showErrors(miss); focusOption(miss[0]); return; }
    open(stages.indexOf(s) + 1, true);
  }

  function visible(o) {
    if (o.cond < 0) return true;
    var p = opts[o.cond];
    return !!p && visible(p) && p.value === o.cv;
  }
  function addons() {
    return opts.filter(function (o) { return visible(o) && o.price; });
  }

  function renderReview(total) {
    if (!reviewEl) return;
    var html = '';
    stages.forEach(function (s, n) {
      if (s.index === 3) return;
      var items = s.opts.filter(function (o) { return visible(o) && o.value && o.type !== 'f'; });
      html += '<div class="cc-review__group"><div class="cc-review__head"><h4>' + esc(s.def.title) + '</h4><button type="button" class="cc-review__edit" data-edit="' + n + '">Edit<span class="visually-hidden"> ' + esc(s.def.title) + '</span></button></div>';
      if (items.length) {
        html += '<dl class="cc-review__list">' + items.map(function (o) {
          return '<div><dt>' + esc(show(splitTitle(o.title)[0]).replace(/^\d+(\.\d+)*\.?\s*/, '')) + '</dt><dd>' + esc(show(o.value)) + (o.price ? ' <span class="cc-review__add">+' + money(o.price) + '</span>' : '') + '</dd></div>';
        }).join('') + '</dl>';
      } else html += '<p class="cc-review__empty">Nothing selected yet.</p>';
      html += '</div>';
    });
    var uploads = opts.filter(function (o) { return o.type === 'f' && visible(o); });
    if (uploads.length) {
      html += '<div class="cc-review__group"><div class="cc-review__head"><h4>Photo upload</h4></div>' + uploads.map(function (o) {
        return '<p class="cc-review__upload">' + (o.value ? 'Attached: ' + esc(o.value) : 'No photo attached' + (o.req ? ' (required)' : ' (optional)')) + '</p>';
      }).join('') + '</div>';
    }
    var add = addons(), sub = 0; add.forEach(function (o) { sub += o.price; });
    var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    html += '<div class="cc-review__totals"><dl>' +
      '<div><dt>Base price</dt><dd>' + money(basePrice) + '</dd></div>' +
      add.map(function (o) { return '<div class="cc-review__addon"><dt>' + esc(show(splitTitle(o.title)[0]).replace(/^\d+(\.\d+)*\.?\s*/, '')) + ': ' + esc(show(o.value)) + '</dt><dd>+' + money(o.price) + '</dd></div>'; }).join('') +
      '<div><dt>Add-on subtotal</dt><dd>' + (sub ? '+' + money(sub) : money(0)) + '</dd></div>' +
      '<div class="cc-review__total"><dt>Total' + (qty > 1 ? ' (each)' : '') + '</dt><dd>' + money(total) + '</dd></div>' +
      (qty > 1 ? '<div class="cc-review__total"><dt>Total for ' + qty + '</dt><dd>' + money(total * qty) + '</dd></div>' : '') +
      '</dl></div>';
    reviewEl.innerHTML = html;
    reviewEl.querySelectorAll('[data-edit]').forEach(function (b) { b.addEventListener('click', function () { open(parseInt(b.dataset.edit, 10), true); }); });
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function update() {
    var total = 0;
    opts.forEach(function (o) {
      var v = visible(o);
      o.el.hidden = !v;
      o.sel.textContent = (o.type === 'b' || o.type === 'i') && o.value ? show(o.value) : '';
      if (v && o.value) {
        o.err.textContent = ''; o.el.classList.remove('is-invalid');
        var ctl = o.group || o.input || o.file; if (ctl) ctl.removeAttribute('aria-invalid');
      }
    });
    addons().forEach(function (o) { total += o.price; });
    priceEls.forEach(function (p) { p.textContent = money(basePrice + total); });

    var allMissing = missingIn(opts).length;
    stages.forEach(function (s, n) {
      var st = stageStatus(s), status = s.btn.querySelector('.cc-stage__status'), summary = s.btn.querySelector('.cc-stage__summary');
      var done = s.index === 3 ? allMissing === 0 : st.missing === 0;
      s.sec.classList.toggle('is-done', done && s.index !== 3);
      if (s.index === 3) status.textContent = allMissing ? allMissing + ' required left' : 'Ready';
      else if (!st.required) status.textContent = 'Optional';
      else status.textContent = st.missing ? st.missing + ' required left' : 'Complete';
      var picked = s.opts.filter(function (o) { return visible(o) && o.value && o.type !== 'f'; }).map(function (o) { return show(o.value); });
      summary.textContent = s.index === 3 ? '' : (picked.length ? picked.slice(0, 3).join(' · ') + (picked.length > 3 ? ' +' + (picked.length - 3) + ' more' : '') : '');
    });

    var progressText = root.querySelector('.cc-progress__text');
    if (progressText && stages[current]) progressText.textContent = 'Step ' + (current + 1) + ' of ' + stages.length + ': ' + stages[current].def.title;
    root.querySelectorAll('.cc-progress__bar span').forEach(function (sp, i) {
      sp.className = i < current ? 'is-past' : i === current ? 'is-current' : '';
      if (i !== current && stages[i] && stages[i].sec.classList.contains('is-done')) sp.className += ' is-done';
    });

    if (atcBtn) {
      atcBtn.setAttribute('aria-disabled', allMissing ? 'true' : 'false');
      atcBtn.classList.toggle('is-blocked', !!allMissing);
    }
    if (atcNote) atcNote.textContent = allMissing ? 'Complete ' + allMissing + ' required selection' + (allMissing > 1 ? 's' : '') + ' to add this build to your cart.' : '';

    if (bar) {
      var t = bar.querySelector('[data-cc-total]'); if (t) t.textContent = money(basePrice + total);
      var a = bar.querySelector('[data-cc-bar-addons]'); if (a) a.textContent = total ? 'incl. +' + money(total) + ' add-ons' : 'No add-ons selected';
      var st2 = bar.querySelector('[data-cc-bar-step]'); if (st2 && stages[current]) st2.textContent = 'Step ' + (current + 1) + ' of ' + stages.length + ' · ' + stages[current].def.title;
    }
    renderReview(basePrice + total);
  }

  function validate() {
    var miss = missingIn(opts);
    if (!miss.length) return true;
    showErrors(miss);
    var first = miss[0], si = -1;
    stages.forEach(function (s, n) { if (s.opts.indexOf(first) > -1) si = n; });
    if (si > -1 && si !== current) open(si, false);
    focusOption(first);
    return false;
  }

  form.addEventListener('submit', function (e) {
    if (!opts.length) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (!validate()) return;
    var btn = form.querySelector('[data-add-button]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    var fd = new FormData(form);
    var qty = parseInt(fd.get('quantity'), 10) || 1;
    var build = uid + '-' + Math.random().toString(36).slice(2, 7);
    opts.forEach(function (o) {
      if (!visible(o) || !o.value) return;
      var key = splitTitle(o.title)[0];
      if (o.type === 'f') { if (o.file.files[0]) fd.append('properties[' + key + ']', o.file.files[0]); }
      else fd.append('properties[' + key + ']', o.value + (o.price ? ' (+' + money(o.price) + ')' : ''));
    });
    fd.append('properties[_build]', build);
    var productTitle = root.dataset.productTitle;
    var items = addons().map(function (o) {
      var id = dict.V[(o.price / 100).toFixed(2)];
      return id ? { id: parseInt(id, 10), quantity: qty, properties: { 'For': productTitle, 'Upgrade': splitTitle(o.title)[0] + ': ' + o.value, '_build': build } } : null;
    }).filter(Boolean);
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart'); }); })
      .then(function () {
        if (!items.length) return;
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add upgrades'); }); });
      })
      .then(function () { window.location.href = '/cart'; })
      .catch(function (err) {
        if (btn) { btn.disabled = false; btn.textContent = label; }
        var msg = root.querySelector('.cc-formerr');
        if (!msg) { msg = el('p', 'cc-err cc-formerr'); msg.setAttribute('role', 'alert'); (atcNote ? atcNote.parentNode : root).appendChild(msg); }
        msg.innerHTML = '<span class="cc-err__icon" aria-hidden="true">!</span> ';
        msg.appendChild(document.createTextNode(err.message));
      });
  }, true);

  /* Keep the live total in step with the variant picker (base price = selected variant). */
  var variantSelect = form.querySelector('[data-variant-select]');
  var productJsonEl = document.querySelector('[data-product-json]');
  if (variantSelect && productJsonEl) {
    variantSelect.addEventListener('change', function () {
      try {
        var p = JSON.parse(productJsonEl.textContent), id = Number(variantSelect.value);
        var v = p.variants.filter(function (x) { return x.id === id; })[0];
        if (v) { basePrice = v.price; if (opts.length) update(); }
      } catch (err) {}
    });
  }
  if (form.querySelector('input[name="quantity"]')) form.querySelector('input[name="quantity"]').addEventListener('input', function () { if (opts.length) update(); });

  Promise.all([
    fetch(root.dataset.dict).then(function (r) { return r.ok ? r.json() : null; }),
    fetch(root.dataset.src).then(function (r) { return r.ok ? r.json() : null; })
  ]).then(function (res) {
    if (!res[0] || !res[1]) return;
    dict = res[0];
    if (!res[1].length) {
      /* No options for this product: same as v1 (notes + express buttons removed, plain add to cart). */
      var notes = form.querySelector('[data-build-notes]'); if (notes) notes.remove();
      document.querySelectorAll('.product-form__dynamic').forEach(function (d) { d.remove(); });
      return;
    }
    build(res[1]);
  }).catch(function () {});
})();
